"use client";

import { ArrowRight, MapPin, Flower2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const parkingMarkers = [{
    id: 1,
    top: "32%",
    left: "28%"
  }, {
    id: 2,
    top: "58%",
    left: "62%"
  }, {
    id: 3,
    top: "44%",
    left: "78%"
  }];
  return <section data-section-id="26" id="our-location" className="bg-background text-foreground relative w-full overflow-hidden">
      <div ref={ref} className={`relative w-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="lg:hidden px-6 pt-16 pb-8">
          <AddressCard />
        </div>

        {}
        <div className="relative w-full h-[480px] lg:h-[600px] overflow-hidden">
          {}
          <div className="absolute inset-0 bg-primary" aria-hidden="true">
            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1440 600" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
              {}
              <rect width="1440" height="600" fill="hsl(145 30% 12%)" />

              {}
              <ellipse cx="280" cy="180" rx="180" ry="120" fill="hsl(145 20% 18%)" opacity="0.85" />
              <ellipse cx="1180" cy="420" rx="200" ry="140" fill="hsl(145 20% 18%)" opacity="0.85" />
              <ellipse cx="960" cy="120" rx="120" ry="80" fill="hsl(145 20% 20%)" opacity="0.7" />
              <ellipse cx="180" cy="480" rx="140" ry="90" fill="hsl(145 20% 18%)" opacity="0.8" />

              {}
              <rect x="0" y="280" width="1440" height="14" fill="hsl(28 35% 45%)" opacity="0.85" />
              <rect x="0" y="420" width="1440" height="10" fill="hsl(28 35% 45%)" opacity="0.75" />
              <rect x="0" y="140" width="1440" height="8" fill="hsl(28 35% 45%)" opacity="0.7" />

              {}
              <rect x="380" y="0" width="12" height="600" fill="hsl(28 35% 45%)" opacity="0.85" />
              <rect x="720" y="0" width="14" height="600" fill="hsl(28 35% 45%)" opacity="0.9" />
              <rect x="1060" y="0" width="10" height="600" fill="hsl(28 35% 45%)" opacity="0.75" />

              {}
              <rect x="0" y="510" width="1440" height="8" fill="hsl(28 35% 45%)" opacity="0.7" transform="rotate(-3 720 514)" />

              {}
              <g opacity="0.75">
                <rect x="420" y="160" width="60" height="80" fill="hsl(145 15% 35%)" />
                <rect x="490" y="180" width="50" height="60" fill="hsl(145 15% 35%)" />
                <rect x="550" y="170" width="70" height="70" fill="hsl(145 15% 35%)" />
                <rect x="630" y="200" width="55" height="40" fill="hsl(145 15% 35%)" />

                <rect x="780" y="160" width="65" height="75" fill="hsl(145 15% 35%)" />
                <rect x="855" y="180" width="55" height="55" fill="hsl(145 15% 35%)" />
                <rect x="920" y="170" width="60" height="65" fill="hsl(145 15% 35%)" />

                <rect x="420" y="310" width="55" height="60" fill="hsl(145 15% 35%)" />
                <rect x="485" y="320" width="60" height="50" fill="hsl(145 15% 35%)" />
                <rect x="555" y="305" width="70" height="65" fill="hsl(145 15% 35%)" />
                <rect x="635" y="325" width="50" height="45" fill="hsl(145 15% 35%)" />

                <rect x="780" y="310" width="70" height="60" fill="hsl(145 15% 35%)" />
                <rect x="860" y="320" width="55" height="50" fill="hsl(145 15% 35%)" />
                <rect x="925" y="305" width="65" height="65" fill="hsl(145 15% 35%)" />

                <rect x="420" y="450" width="60" height="55" fill="hsl(145 15% 35%)" />
                <rect x="490" y="460" width="55" height="45" fill="hsl(145 15% 35%)" />
                <rect x="555" y="445" width="70" height="60" fill="hsl(145 15% 35%)" />

                <rect x="780" y="450" width="65" height="55" fill="hsl(145 15% 35%)" />
                <rect x="855" y="460" width="55" height="45" fill="hsl(145 15% 35%)" />
                <rect x="920" y="445" width="60" height="60" fill="hsl(145 15% 35%)" />
              </g>

              {}
              <g opacity="0.3" stroke="hsl(145 10% 85%)" strokeWidth="1" fill="none">
                <line x1="0" y1="60" x2="1440" y2="60" />
                <line x1="0" y1="360" x2="1440" y2="360" />
                <line x1="200" y1="0" x2="200" y2="600" />
                <line x1="540" y1="0" x2="540" y2="600" />
                <line x1="880" y1="0" x2="880" y2="600" />
                <line x1="1240" y1="0" x2="1240" y2="600" />
              </g>

              {}
              <path d="M 0 540 Q 360 510, 720 530 T 1440 520 L 1440 600 L 0 600 Z" fill="hsl(198 42% 88%)" opacity="0.5" />
            </svg>

            {}
            <div className="absolute inset-0 bg-gradient-to-b from-background/20 via-transparent to-background/40 pointer-events-none" />
          </div>

          {}
          {parkingMarkers.map((marker, i) => <div key={marker.id} data-index={i} className="absolute -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-8 h-8 rounded-lg bg-primary/90 shadow-md border border-border/40" style={{
          top: marker.top,
          left: marker.left
        }} aria-label="Parking">
              <span className="text-xs font-semibold font-default text-primary-foreground">
                P
              </span>
            </div>)}

          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full flex flex-col items-center" style={{
          zIndex: 5
        }}>
            <div className="relative flex items-center justify-center">
              {}
              <span className="absolute inline-flex h-20 w-20 rounded-lg bg-ring/30 animate-ping" />
              <span className="absolute inline-flex h-14 w-14 rounded-lg bg-ring/40 animate-ping" style={{
              animationDelay: "0.6s"
            }} />
              {}
              <div className="relative flex items-center justify-center w-14 h-14 rounded-lg bg-ring shadow-lg ring-4 ring-ring/20">
                <Flower2 className="w-7 h-7 text-primary" strokeWidth={1.5} />
              </div>
              {}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-3 h-3 rotate-45 bg-ring" />
            </div>
          </div>

          {}
          <div className="hidden lg:block absolute top-20 left-20 w-[360px]" style={{
          zIndex: 10
        }}>
            <AddressCard />
          </div>
        </div>
      </div>
    </section>;
}
function AddressCard() {
  return <div className="bg-card text-card-foreground rounded-3xl shadow-lg p-10 border border-border">
      {}
      <div className="flex items-center gap-2 mb-6">
        <MapPin className="w-3.5 h-3.5 text-ring" strokeWidth={2} />
        <span className="font-mono text-xs uppercase tracking-widest text-ring font-bold">
          Visit Our School
        </span>
      </div>

      {}
      <div className="mb-6">
        <p className="font-default text-2xl leading-tight text-foreground">
          Parkwoods-Donalda
        </p>
        <p className="font-default text-2xl leading-tight text-foreground">
          North York, ON
        </p>
      </div>

      {}
      <div className="w-12 h-px bg-ring mb-6" />

      {}
      <div className="space-y-3 mb-8">
        <p className="font-default text-sm italic text-muted-foreground leading-relaxed">
          Located in the heart of the community
        </p>
        <p className="font-default text-xs text-muted-foreground leading-relaxed">
          Easy access via major transit routes
        </p>
      </div>

      {}
      <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary/80 font-default text-sm font-semibold tracking-wide group no-underline hover:no-underline">
        <Link to="/ContactUsPage">
          <span>Get Directions</span>
          <ArrowRight className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
        </Link>
      </Button>
    </div>;
}